import React from 'react';
import { useNavigate } from 'react-router-dom';
import './StatusPages.css';
import Footer from './Footer';
import HomeButton from './HomeButton';

const NotFound = () => {
  const navigate = useNavigate();

  return (
    <div className="status-page">
        <HomeButton/>
      <div className="status-container">
        <h1 className="glitch-text">404</h1>
        <div className="status-card">
          <h2>Lost in Space</h2>
          <p>The coordinates you entered do not exist in the OZIA network.</p>
          <button className="status-btn" onClick={() => navigate('/')}>
            Return to Base
          </button>
        </div>
      </div>
                  <div className="footer-wrapper">
                  <Footer />
              </div>
    </div>
  );
};

export default NotFound;